<template>
<div class="content">
	<div class="my-title">
		<Row :gutter="10">
			<Col :span="params.product=='companyGroupEmployer'?18:12">我的订单</Col>
			<Col span="6" v-if="params.product!='companyGroupEmployer'">
				<Select v-model="params.applicantInfo" placeholder="请选择服务商" clearable @on-change="getList()">
					<Option :value="item.bizCode" v-for="(item, index) in companyList" :key="index">{{item.name}}</Option>
				</Select>
			</Col>
			<Col span="6">
				<Select v-model="params.product" placeholder="请选择产品" @on-change="productChange">
					<Option value="companyGroupEmployer">企业团体雇主责任险</Option>
					<Option value="TRUCK_EMPLOYERS_LIABILITY_INSURANCE">货车雇主责任险</Option>
				</Select>
			</Col>
		</Row>
	</div>
	<Tabs v-model="status">
        <TabPane label="全部订单" name="ALL"></TabPane>
        <TabPane label="待支付" name="UNPAID"></TabPane>
        <TabPane label="已支付" name="PAID"></TabPane>
        <TabPane label="已关闭" name="CLOSED"></TabPane>
    </Tabs>
    <div class="orders">
    	<OrderItem v-for="(item,index) in list.data" :key="index" :info="item" @on-load="getList" />
    	<div class="nothing" v-if="list.data&&list.data.length==0">暂无数据</div>
    	<div class="page">
    		<Page 
    			:total="list.total" 
    			show-total
    			@on-change="getList" />
    	</div>
    </div>
</div>
</template>
<script>
import OrderItem from '../common/OrderItem'
import { mapState } from 'vuex'
export default {
	components:{ OrderItem },
	data () {
		return {
			params:{
				product:this.$route.query.product||'companyGroupEmployer'
			},
			status:'ALL',
			list:{},
			page:1,
			companyList:[],
			loaded:false
		}
	},
	watch:{
		status (v) {
			this.getList()
		},
		userInfo(v){
			if(this.checkLogin(true)&&!this.loaded){
				this.loaded=true
				this.getList();
				this.getCompanyList();
			}
		}
	},
	computed:{
		...mapState({
			userInfo:state=>state.common.info
		}),
	},
	mounted () {
		this.$nextTick(()=>{
			if(this.checkLogin(false)&&!this.loaded){
				this.loaded=true;
				this.getList();
				this.getCompanyList();
			}
		})
	},
	methods:{
		// 检测登录
		checkLogin(toLogin){
			if(!this.userInfo.userId){
				if(toLogin&&location.href&&location.href.indexOf('/common.html#/login')==-1){
					window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(location.href);
				}
				return false
			}else{
				return true
			}
		},
		// 获取服务商列表
		getCompanyList(){
			this.$axios.get('/broker/enterprise/findHaveBind').then(res=>{
				this.companyList=res;
			}).catch(e=>{
				console.log(e)
			});
		},
		getList (page=1) {
			let form={};
			let url=''
			if(this.params.product=='companyGroupEmployer'){
				url='/employerLiability/getMyOrder.all'
				form={
					page,
					count:10,
					statusType:this.status,
				}
			}else{
				url='/broker/order/list.json.all'
				form={
					page,
					count:10,
					orderStatus:this.status=='ALL'?'':this.status,
					bizId:this.params.product,
					applicantInfo:this.params.applicantInfo
				}
			}
			this.$axios.post(url,form).then(res=>{
				this.page=page;
				this.list = res
			})
		},
		productChange(val){
			this.$router.replace({
				path:this.$route.path,
				query:{
					product:this.params.product
				}
			})
			this.getList()
		}
	},
}
</script>
<style scoped lang="less">
	.content{
		padding:0 15px 15px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/order/index.vue